import React, { useState } from 'react';
import { API_URL } from '../../config';
import '../../styles/Login.scss';
import { auth, provider } from '../config/firebaseConfig';
import { signInWithPopup } from 'firebase/auth';
import useUserSession from '../useUserSession'; // Import du hook personnalisé
import logoGrouping from '../assets/img/logo_Grouping.png'

function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showError, setShowError] = useState('');
  const { setUser, logout } = useUserSession(); // Utilisation du hook

  // Gère la saisie de l'utilisateur
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    switch (name) {
      case 'email':
        if (emailRegex.test(value)) {
          if (errors[name]) {
            delete errors[name];
          }
        } else {
          errors[name] = 'Adresse email invalide';
        }
        break;
      case 'password':
        if (value.length > 0) {
          if (errors[name]) {
            delete errors[name];
          }
        } else {
          errors[name] = 'Le mot de passe ne doit pas être vide';
        }
        break;
      default:
        if (errors[name]) {
          delete errors[name];
        }
        break;
    }
    setErrors({ ...errors });
  };

  // Valide tout le formulaire avant soumission
  const validateForm = () => {
    let formErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email) {
      formErrors.email = 'Adresse Mail est requise';
    } else if (!emailRegex.test(formData.email)) {
      formErrors.email = 'Adresse Mail invalide';
    }

    if (!formData.password) {
      formErrors.password = 'Mot de passe est requis';
    }

    return formErrors;
  };

  // Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Valider le formulaire localement
    const formErrors = validateForm();
    setErrors(formErrors);
  
    // Si des erreurs existent, ne pas soumettre
    if (Object.keys(formErrors).length > 0) {
      return;
    }
  
    setIsSubmitting(true);
  
    try {
      // Étendre formData avec typeconnexion
      const payload = {
        ...formData,
        typeconnexion: 'admin',
      };
  
      const response = await fetch(`${API_URL}/api/user/signinAdmin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload), // Envoyer le payload étendu
      });
  
      const result = await response.json();
  
      if (response.ok) {
        
        const token = result.token.replace('Bearer ', ''); // Nettoyage du token
        // Si l'authentification est réussie
        if (result.status === 0) {
          setShowError('');
          localStorage.setItem('email', result.user.email);
          localStorage.setItem('uid', result.user._id);
          localStorage.setItem('name', result.user.name);
          localStorage.setItem('token', token);
          localStorage.setItem('photo', result.user.photo);
          localStorage.setItem('role', result.user.role);
          localStorage.setItem('locked', result.user.locked); 
          // Mise à jour de l'utilisateur dans le contexte global
          setUser({
            uid: result.user._id,
            name: result.user.name,
            email: result.user.email,
            photo: result.user.photo,
            role: result.user.role,
            token: token, // Ajout du token
            locked: result.user.locked
          });
  
        } else {
          // Afficher les erreurs retournées par l'API (status = 1)
          setShowError(result.message || 'Erreur inconnue.');
          logout()
        }
      } else {
        // Gérer les erreurs HTTP non OK
        setShowError(result.message || `Erreur ${response.status}: ${response.statusText}`);
        console.error('Erreur lors de la connexion :', result);
        logout()
      }
    } catch (error) {
      // Gérer les erreurs réseau ou autres
      logout()
      setShowError('Une erreur est survenue. Veuillez vérifier votre connexion.');
      console.error('Erreur lors de la requête API :', error);
    } finally {
      setIsSubmitting(false);
    }
  };  

  //connexion avec google
  const handleConnectWithGoogle = async () => {
    try {
      const data = await signInWithPopup(auth, provider);
  
      // Enregistrer les informations utilisateur localement
      /* localStorage.setItem('email', data.user.email);
      localStorage.setItem('name', data.user.displayName); */
      localStorage.setItem('photo', data.user.photoURL);
  
      // Connexion à l'API
      const response = await fetch(`${API_URL}/api/user/signinwithgoogleadmin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          password: data.user.uid,
          email: data.user.email,
          name: data.user.displayName,
          photo: data.user.photoURL,
          typeconnexion: 'admin',
        }),
      });
  
      // Vérifier la réponse
      if (response.ok) {
        const responseData = await response.json();
        const token = responseData.token.replace('Bearer ', ''); // Nettoyage du token
        
        setShowError('');
        localStorage.setItem('email', responseData.user.email);
        localStorage.setItem('uid', responseData.user._id);
        localStorage.setItem('name', responseData.user.name);
        localStorage.setItem('role', responseData.user.role);
        localStorage.setItem('token', token);
        localStorage.setItem('photo', responseData.user.photo);
        localStorage.setItem('locked', responseData.user.locked); 
        // Mise à jour de l'utilisateur dans le contexte global
        setUser({
          uid: responseData.user._id,
          name: responseData.user.name,
          email: responseData.user.email,
          photo: responseData.user.photo,
          role: responseData.user.role,
          token: token, // Ajout du token
          locked: responseData.user.locked
        });
      } else {
        // Gérer les erreurs HTTP
        const responseData = await response.json();
        setShowError(responseData.message || 'Erreur inconnue.');
        console.error('Erreur lors de la connexion:', responseData);
        logout()
      }
    } catch (error) {
      // Gérer les erreurs réseau ou autres
      console.error('Erreur lors de la connexion avec Google:', error);
      setShowError('Une erreur est survenue lors de la connexion. Veuillez réessayer.');
      logout()
    } finally {
      setIsSubmitting(false);
    }
  };
  

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-9 col-lg-12 col-xl-10">
          <div className="card shadow-lg o-hidden border-0 myLogin">
            <div className="card-body p-0">
              <div className="row">
                {/* Partie gauche : Formulaire de connexion */}
                <div className="col-lg-6">
                  <div className="p-5">
                    <div className="text-center">
                      <img
                        src={logoGrouping}
                        style={{ height: '100px' }}
                        alt="Logo Grouping Admin"
                      />
                      <h1 className="text-dark mb-3">GROUPING ADMIN</h1>
                      {showError !== '' && (
                        <h4 className="text-danger mb-2">{showError}</h4>
                      )}
                    </div>

                    {/* Formulaire */}
                    <form className="user">
                      {/* Champ e-mail */}
                      <div className="mb-3">
                        <input
                          className="form-control form-control-user"
                          type="email"
                          id="exampleInputEmail"
                          aria-describedby="emailHelp"
                          placeholder="Entrez votre adresse mail..."
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                        {errors.email && (
                          <p className="text-danger mt-1">{errors.email}</p>
                        )}
                      </div>

                      {/* Champ mot de passe */}
                      <div className="mb-3">
                        <input
                          className="form-control form-control-user"
                          type="password"
                          id="exampleInputPassword"
                          placeholder="Mot de passe"
                          name="password"
                          value={formData.password}
                          onChange={handleInputChange}
                        />
                        {errors.password && (
                          <p className="text-danger mt-1">{errors.password}</p>
                        )}
                      </div>

                      <div className="mb-3" />

                      {/* Bouton de connexion */}
                      <button
                        className="btn btn-primary d-block btn-user w-100"
                        type='button'
                        onClick={handleSubmit}
                        style={{ background: '#033e8c', border: 'unset' }}
                        disabled={isSubmitting}
                      >
                        {!isSubmitting ? (
                          <span>Se connecter</span>
                        ) : (
                          <span
                            className="spinner-border text-light"
                            role="status"
                          />
                        )}
                      </button>

                      <hr />

                      {/* Connexion avec Google */}
                      <button
                        className="btn btn-primary d-block btn-google btn-user w-100 mb-2"
                        type='button'
                        style={{ background: '#f25c05', border: 'unset' }}
                        onClick={handleConnectWithGoogle}
                      >
                        <i className="fab fa-google" />
                        &nbsp; Se connecter avec Google
                      </button>

                      <hr />
                    </form>

                    <div className="text-center">
                      <a className="small" href="forgot-password.html">
                        Mot de passe oublié?
                      </a>
                    </div>
                  </div>
                </div>

                {/* Partie droite : Image de fond */}
                <div className="col-lg-6 d-none d-lg-flex">
                  <div
                    className="flex-grow-1 bg-login-image"
                    style={{
                      background:
                        'url("assets/img/dogs/freight-airplane-flying-overseas-shipping-container-2.webp") right / cover',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
}

export default Login;